import React, { Fragment, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import toast from "react-hot-toast";
import { AiFillCheckCircle, AiFillCloseCircle } from "react-icons/ai";
import { CgDanger } from "react-icons/cg";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { useNavigate, useParams } from "react-router-dom";
import { Errors } from "../../../Request/Values";
import { borderBottomTitle, webTemp } from "../../../Utils/styles";
import AccessLink from "../../Common/AccessLink";
import Loading from "../../Common/Loading";
import RenderBasket from "../../Common/RenderBasket";
import Map from "../../Common/SingleMap";
import { Image, Information } from "./Components/Details";
import { GetItem } from "./Components/Services";
import { Tab } from "./Components/Tab";
import SingleApp from "../../../App/Views/ItemSingle/components/SingleApp";

function Single({ isApp, isWebview }) {

  const { slug } = useParams();
  const location = useLocation();
  const renderSlug = () => {
    let slugList = slug && slug.split("-");
    let res = "";
    slugList &&
      slugList.map(ch => {
        if (!(typeof ch == "number")) {
          res += " " + ch;
        }
      });
    return res.trim();
  };
  const navigate = useNavigate();
  const initialState = {
    loading: true,
    favorite_status: null,
    sans_loading: true,
    data: {
      data: null,
      current_page: null,
    },
  };
  const [state, setState] = useState(initialState);
  const dispatch = useDispatch();
  const basket = useSelector(state => state.basket);
  const details = useRef(null);
  const timeTable = useRef(null);

  const goToDetails = () => details.current.scrollIntoView();
  const goToTimeTable = () => timeTable.current.scrollIntoView();
  useEffect(() => {
    Handler();
  }, [location.pathname]);
  useEffect(() => {
    scrollToTop();
  }, [state.loading]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const Handler = () => {
    setState({ ...state, loading: true });
    GetItem(slug, isApp).then(result => {
      if (result) {
        setState({
          loading: false,
          favorite_status: result.favorite,
          data: result,
        });
      } else {
        toast.error(Errors.errorServer);
        // navigate(-1);
      }
    });
    scrollToTop();
  };
  // if (state.loading) {
  //   return (
  //     <>
  //       <Helmet>
  //         <title>نیکوتن | {renderSlug(slug)} </title>
  //         <meta name="description" content={renderSlug(slug)} />
  //         <link rel="canonical" href={`/Items/${slug}`} />
  //       </Helmet>
  //       <Loading count={1} col={12} height={600} />
  //     </>
  //   );
  // }
  const { Items } = state.data;
  const ldJson = Items?.seo?.seoSchema && JSON.parse(Items?.seo?.seoSchema);

  const renderTag = tags => {
    let res = "";
    if (tags && Array.isArray(tags) && tags.length > 0) {
      tags.map((tag, count) => {
        if (tags.length - 1 === count) {
          res = res + tag.label;
          return;
        }
        res = res + tag.label + " ، ";
      });
    } else {
      res = "ثبت نشده";
    }
    return res;
  };
  const convertIFrame = data => { };
  const renderDesc = () => {
    if (!state.loading) {
      if (Items.seo && Items.seo.seoDescription) {
        return Items.seo.seoDescription;
      } else {
        return renderSlug(slug);
      }
    }
  };

  const rendeKeyWords = () => {
    let res = "";
    if (!state.loading) {
      if (
        Items.seo &&
        Items.seo.seoKeyword &&
        Array.isArray(Items.seo.seoKeyword)
      ) {
        Items.seo.seoKeyword.map((key, count) => {
          if (Items.seo.seoKeyword.length - 1 == count) {
            res = res + key;
          } else {
            res = res + key + ", ";
          }
        });
        return res;
      } else {
        return renderSlug(slug);
      }
    }
  };
  return (
    <Fragment>
      <Helmet>
        <title>{renderSlug(slug)} | نیکوتن</title>
        <meta name="description" content={renderDesc()} />
        <meta name="robots" content="index, follow" />
        <meta name="keywords" content={rendeKeyWords()} />
        <link rel="canonical" href={window.origin + `/Items/${slug}`} />
        <script type="application/ld+json" data-react-helmet="true">
          {ldJson &&
            JSON.stringify(ldJson)
          }
        </script>
      </Helmet>

      {/* در صورت موبایل بودن شرط زیر اجرا می شود  */}
      {isApp && (
        state.loading
          ? (
            <>
              <Loading count={1} col={12} height={100} />
              <Loading count={3} col={12} height={40} />
              <Loading count={1} col={12} height={100} />
            </>
          )
          : (<SingleApp isWebview={isWebview} data={state} details={details} timetableRef={timeTable} />)
      )}

      {/* در صورت وب بودن شرط زیر اجرا می شود  */}
      {!isApp &&
        <div id="single-item-page">
          <div className={"container " + (window.screen.width < 768 && "px-1")} id="info">
            <div className="row">
              <div className="col-12 mt-4">
                <AccessLink single={true} data={Items} />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div style={{ ...webTemp }}>
                  {state.loading ? (
                    <Loading count={1} col={12} height={400} />
                  ) : (
                    <>
                      <div style={{ ...borderBottomTitle }} className="mb-3">
                        <div className="d-flex justify-content-between align-items-center flex-wrap">
                          <h1
                            className="item-name-title pb-3 h2 "
                            style={{
                              fontWeight: "500",
                            }}
                          >
                            {Items.name}
                          </h1>
                          <div>
                            {/* <button className="btn bg-light-grey mb-2 me-3 py-2">
                            <img
                              src={
                                window.origin + "/WebSide/assets/images/37.png"
                              }
                              alt="همه ملاقات"
                              style={{
                                width: "18px",
                                height: "18px",
                                marginLeft: "6px",
                              }}
                            />
                            <span
                              className="ps-2"
                              style={{
                                borderRight: "1px solid #000",
                              }}
                            >
                              افزودن به علاقه مندی ها
                            </span>
                          </button> */}
                            <button
                              className="btn bg-red text-white mb-2 py-2"
                              onClick={goToTimeTable}
                            >
                              <img
                                className=""
                                src={
                                  window.origin + "/WebSide/assets/images/44.png"
                                }
                                alt="همه ملاقات"
                                style={{
                                  width: "18px",
                                  height: "18px",
                                  marginLeft: "6px",
                                }}
                              />
                              <span
                                className="px-4"
                                style={{
                                  borderRight: "1px solid #eee",
                                }}
                              >
                                رزرو باشگاه
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-lg-7 order-0">
                          <Image
                            data={
                              state.data &&
                              state.data.Items &&
                              state.data.Items.images
                            }
                            alt={state.data.Items.images_alt}
                            name={state.data.Items.name}
                          />
                        </div>

                        <div className="col-md-12 col-lg-5 order-md-2 order-lg-1 d-flex flex-column">
                          <div
                            className="top-icon-container row px-0 mt-2 mb-0 py-2 py-lg-0 "
                            style={{ ...webTemp }}
                          >
                            {[
                              {
                                icon: "34",
                                text: "ظرفیت",
                                value: Items.capacity || 0,
                              },
                              {
                                icon: "35",
                                text: "رزرو ها",
                                value: Items.reserves_count,
                              },
                              {
                                icon: "36",
                                text: "نظرات",
                                value: Items.comments_count,
                              },
                              {
                                icon: "37",
                                text: "امتیازکاربران",
                                value: Math.ceil(Items.comments_avg_score) || 5,
                              },
                            ].map((item, key) => {
                              return (
                                <div
                                  className="col-3 col-lg-6 col-xl-3"
                                  key={key}
                                >
                                  <div className="py-1 py-md-3 py-lg-3 pt-xl-4 pb-xl-3">
                                    <h5 className="d-flex justify-content-center align-items-center my-0 small top">
                                      <img
                                        src={
                                          window.origin +
                                          `/WebSide/assets/images/${item.icon}.png`
                                        }
                                        alt="همه ملاقات"
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                          marginLeft: "6px",
                                        }}
                                      />
                                      <span style={{ fontWeight: "400" }}>
                                        {item.text}
                                      </span>
                                    </h5>
                                    <h6
                                      style={{ color: "#E42A3F" }}
                                      className="text-center mb-0 mt-2 top-icon-result"
                                    >
                                      {item.value}
                                    </h6>
                                  </div>
                                </div>
                              );
                            })}
                          </div>

                          <div
                            style={{
                              padding: "10px 0px 0px 0px",
                              width: "100%",
                              height: "100%",
                            }}
                          >
                            <Map
                              style={{ width: "100%", height: "100%" }}
                              position={
                                Items.location && Items.location.length > 5
                                  ? Items.location
                                  : "36.258241314877736,58.83325211656804"
                              }
                              title={
                                Items.location && Items.location.length > 5
                                  ? Items.name
                                  : "لوکیشن ثبت نشده است"
                              }
                            />
                          </div>
                          {/* ----------------------------- new row  */}
                          <div className="row p-0">
                            <div className="col-12">
                              <div
                                className="d-flex mt-3"
                                style={{
                                  fontWeight: "400",
                                }}
                              >
                                <img
                                  src={
                                    window.origin +
                                    `/WebSide/assets/images/${39}.png`
                                  }
                                  alt="همه ملاقات"
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    marginLeft: "10px",
                                  }}
                                />
                                {Items.address}{" "}
                              </div>
                              <div className="d-flex justify-content-between align-items-center">
                                <div>
                                  <div
                                    className="d-flex mt-3"
                                    style={{
                                      fontWeight: "400",
                                    }}
                                  >
                                    <img
                                      src={
                                        window.origin +
                                        `/WebSide/assets/images/${40}.png`
                                      }
                                      alt="همه ملاقات"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        marginLeft: "10px",
                                      }}
                                    />
                                    {renderTag(Items.tags)}
                                  </div>
                                  <div
                                    className="d-flex mt-3"
                                    style={{
                                      fontWeight: "400",
                                    }}
                                  >
                                    <img
                                      src={
                                        window.origin +
                                        `/WebSide/assets/images/${41}.png`
                                      }
                                      alt="همه ملاقات"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        marginLeft: "10px",
                                      }}
                                    />
                                    {Items.itemmanager &&
                                      Array.isArray(Items.itemmanager) &&
                                      Items.itemmanager.length > 0
                                      ? Items.itemmanager[0].fullname
                                      : "نیکوتن"}
                                  </div>
                                </div>
                                <button
                                  onClick={goToDetails}
                                  className="btn d-flex flex-column justify-content-center align-items-center new-box-shadow mt-4"
                                >
                                  <img
                                    src={
                                      window.origin +
                                      `/WebSide/assets/images/${42}.png`
                                    }
                                    alt="همه ملاقات"
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      marginLeft: "10px",
                                    }}
                                  />
                                  اطلاعات و نظرات
                                </button>
                              </div>
                            </div>
                            <div className="col-12 mt-4 d-flex justify-content-between">
                              <div
                                className="  "
                                //
                                style={{
                                  backgroundColor:
                                    Items.timetable == "deactive"
                                      ? "rgb(228, 42, 63)"
                                      : "#65CB77",
                                  color: "#fff",
                                  borderRadius: "5px",
                                  // minWidth: "240px",
                                  // margin: "10px 0 10px auto"
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "5px 20px",
                                  fontWeight: "400",
                                }}
                              >
                                <div
                                  style={{
                                    marginLeft: "8px",
                                    fontWeight: "400",
                                  }}
                                >
                                  {Items.timeTable == "deactive" ? (
                                    <AiFillCloseCircle />
                                  ) : (
                                    <AiFillCheckCircle />
                                  )}
                                </div>

                                {Items.timetable !== "deactive"
                                  ? "رزرو آنلاین فعال"
                                  : "رزرو آنلاین غیر فعال"}
                              </div>

                              <div
                                className="py-1  "
                                onClick={goToTimeTable}
                                style={{
                                  backgroundColor: "#E42A3F",
                                  color: "#fff",
                                  maxWidth: "200px",
                                  borderRadius: "5px",
                                  marginRight: "8px",
                                  flex: 1,
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  fontWeight: "400",

                                  // margin: "0 0 10px auto"
                                }}
                              >
                                رزرو باشگاه
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>

          {state.data && state.data?.Items?.necessary_description &&
            <div className={"container " + (window.screen.width < 768 && "px-1")} >
              <div className="" style={{ ...webTemp }}>

                <h5 style={{ color: "#E42A3F", borderBottom: "1px solid #eee", paddingBottom: "10px" }} className="reserve-item-name mb-3">
                  <CgDanger className="mx-2 " size={35} />
                  توضیحات مهم
                </h5>

                <div className="px-4">
                  <Information description={state.data && state.data.Items.necessary_description} />
                </div>

              </div>
            </div>
          }

          <div className={"container " + (window.screen.width < 768 && "px-1")} >
            <div className="row">
              <div className="col-12">
                <Tab
                  loading={state.loading}
                  Item={state.data && state.data.Items}
                  timeTable={state.data && state.data.timetable}
                  paranetItems={state && state.data}
                  ItemAvgScore={state.data && state.data.ItemAvgScore}
                  details={details}
                  timetableRef={timeTable}
                  looklikeitem={state.data && state.data.likeitem}
                />
              </div>
            </div>
          </div>
        </div>
      }
      <RenderBasket basket={basket} />
    </Fragment >
  );
}

export default Single;
